export const LEAGUE_CREDIT_TYPE = 'personal_store_credit_balance';
